import { Container } from "@mui/material";
import React from "react";
import ProfileCandidatures from "../components/profile/ProfileCandidatures";
import { useUserAuth } from "../context/UserAuthContext";

const Candidatures = () => {
  const { user } = useUserAuth();
  return (
    <Container maxWidth={"xl"}>{user && <ProfileCandidatures />}</Container>
  );
};

export default Candidatures;
